/*
サイズ調整用の関数
解像度が変わってもレイアウトが崩れることなく表示される

入力
LandscapeValue:1920px * 1080px(横長)の時の設定値
VerticalValue :1080px * 1920px(縦長)の時の設定値
を入力

サイズを調整するときは
画面を1920px * 1080pxにして入力値を変更してください
*/

// Width
export const WidthCalculation = (landscapeValue : number,verticalValue : number ) => {
    let value:number

    // 画面が横長の場合
    if(window.innerHeight < window.innerWidth){
        value = window.innerWidth * landscapeValue / 1920
    }

    // 画面が縦長の場合
    else{
        value = window.innerWidth * verticalValue / 1080
    }
    return value; 
}

// Height
export const HeightCalculation = (landscapeValue : number,verticalValue : number ) => {
    let value:number

    // 画面が横長の場合
    if(window.innerHeight < window.innerWidth){
        value = window.innerHeight * landscapeValue / 1080
    }

    // 画面が縦長の場合
    else{
        value = window.innerHeight * verticalValue / 1920
    }
    return value; 
}